<!-- PERFORMANCE SEEMS GOOD UP TO 50 ROWS AT A TIME, 100 WAS BAD -->

<template>
	<v-container ref="fullPage" :style="darkTheme ? 'background-color: black;' : 'background-color: white;'" fluid class="fullpage">
		
		<v-toolbar height="80">
			<v-layout>
			<v-flex>
			<v-toolbar-title class="ml-5 topTitle">	
	  			<v-layout align-center row fill-height>			
					<img src="@/images/ua_block_rgb_3.3c82a4c.png" class="blocka">
					<a href="/" 
						style="text-decoration: none;"" 
						:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
							Interactive Floorplans 
					</a>				
			 	</v-layout>
			</v-toolbar-title>			
			</v-flex>
			<v-spacer></v-spacer>
			<v-flex xs1 class="text-xs-right"><DBToggleBtn /></v-flex>
		</v-layout>
		</v-toolbar>
		<v-progress-linear class="mt-0" v-if="!this.userProfile.name" color="blue" indeterminate></v-progress-linear>
		<div class="scrollable">
		<v-layout column class="pt-5" style="width:1200px;">
			<v-card v-if="this.userProfile.name" class="ml-5 pt-4 pb-5 px-5">

				<v-card-title class="headline">{{`Current ${this.currentRooms && this.currentRooms.length>1 ? "Rooms" : "Room"} for: ${this.userProfile.name}`}}</v-card-title>

				<v-card-text>
					<v-flex class="subheading mt-1">
						<v-list>
						<v-list-tile row class="slimTile" v-for="currentRoom, i in currentRooms" :key="currentRoom.key" 
							style="margin-bottom:2px;"
							@click="">
							<v-flex shrink>{{i+1}}:</v-flex>
							<v-flex xs1 class="pl-2">{{currentRoom.bldgAlpha}}</v-flex>
							<v-flex xs4 class="pl-2 text-truncate" style="padding-bottom: 2px;" >
								{{currentRoom.bldgName}}
							</v-flex>
							<v-flex xs1 class="text-xs-right">Room:</v-flex>
							<v-flex xs1 class="pl-2">{{currentRoom.number}}</v-flex>
							<v-flex xs1 class="text-xs-right">Dept:</v-flex>
							<v-flex xs4 class="pl-2">{{currentRoom.deptID}} - {{currentRoom.deptName}}</v-flex>
						</v-list-tile>
						</v-list>
					</v-flex>
				</v-card-text>
				<v-card-actions v-if="!showModify" class="mt-4">
		          	<v-btn color="green darken-1"  @click.native="confirm">Confirm</v-btn>
		          	<v-btn color="green darken-1" class="mr-4"  @click.native="showModify=true">Modify</v-btn>
		        </v-card-actions>
		        <v-card-title class="headline pt-5" v-if="showModify">{{`Update ${this.newRooms && this.newRooms.length>1 ? "Rooms" : "Room"} for: ${this.userProfile.name}`}}</v-card-title>
		        <v-card-text v-if="showModify" class="pt-0">

					<v-flex class="subheading">
						<v-progress-linear class="" v-if="loading" color="blue" indeterminate></v-progress-linear>
						<v-list>
							<v-list-tile row>
								<v-flex xs1></v-flex>
								<v-flex xs6 class="pl-2">Building</v-flex>
								<v-flex xs2 class="pl-2">Room</v-flex>
								<v-flex xs2 class="pl-2">Dept</v-flex>
								<v-flex xs1></v-flex>
							</v-list-tile>
							<v-divider class="pb-2"></v-divider>
						<v-list-tile class="ouTile" v-for="room, i in newRooms" :key="room.key" style="margin-bottom:2px;" @click="">
							
							<v-flex xs1>{{i+1}}:</v-flex>
							<v-flex xs6>
								<v-autocomplete
									ref="autocomplete"
									v-model="room.bldgAlpha"
									hide-no-data
									auto-select-first
									autocomplete
									solo
									flat
									style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
									:items="buildingItems"
									:filter="customFilter"
									label="Building Name / Number / Addr"
									single-line
									@change="loadRoomDictionary"
									>
									<template
								        slot="selection"
								        slot-scope="{ item, tile }"
								      >
								      	<v-layout >
								        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
								        	{{item.bldgAlpha}}
								        </v-list-tile-avatar>
								        <v-list-tile-content>
								          <v-list-tile-title >
								          	{{item.name}}
								          </v-list-tile-title>
								          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
								        </v-list-tile-content>
								    	</v-layout>
								      </template>
									<template
								        slot="item"
								        slot-scope="{ item, tile }"
								      >
								        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
								        	{{item.bldgAlpha}}
								        </v-list-tile-avatar>
								        <v-list-tile-content>
								          <v-list-tile-title>
								          	{{item.name}}
								          </v-list-tile-title>
								          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
								        </v-list-tile-content>
								      </template>
								</v-autocomplete>
							</v-flex>

							<v-flex xs2>
								<v-autocomplete						
									v-model="room.number"
									:loading="room.bldgAlpha && !buildingRooms[room.bldgAlpha]"
									autocomplete
									auto-select-first
									solo
									flat
									:items="buildingRooms[room.bldgAlpha]"
									item-value="number"
									item-text="number"
									label="Room"
									single-line
									@change="setDeptDefault(room)"
								>
									<template slot="no-data">
										<v-card flat class="px-3">
											{{room.bldgAlpha ? 'Loading...' : 'Choose a Building First'}} 
										</v-card>
								  	</template>
								</v-autocomplete>
							</v-flex>

							<v-flex xs2>
								<v-autocomplete				
									v-model="room.pctKey"
									:loading="room.bldgAlpha && !buildingRooms[room.bldgAlpha]"
									autocomplete
									auto-select-first
									solo
									:disabled="roomDepts(room) && roomDepts(room).length==1"
									flat
									:items="roomDepts(room)"
									item-value="value"
									item-text="text"
									label="Choose Dept"
									single-line
								>
									<template slot="no-data">
										<v-card flat class="px-3">
											{{room.bldgAlpha ? 'Loading...' : 'Choose a Building First'}} 
										</v-card>
								  	</template>
								</v-autocomplete>
							</v-flex>

							<v-flex xs1  >
								<v-tooltip top>
									<v-btn icon slot="activator">                
					                	<v-icon small  @click="delItem(i)" color="red lighten-2">close</v-icon>          
					            	</v-btn>
						            <span>Delete</span>
					            </v-tooltip>
							</v-flex>
							
						</v-list-tile>
						<v-flex style="position: relative; left: -5px;"><v-btn icon @click="addLine" ><v-icon color="grey darken-2">add</v-icon></v-btn></v-flex>
						</v-list>
					</v-flex>
				</v-card-text>
				<v-card-actions v-if="showModify" class="mt-4 ml-5">
		          	<v-btn color="green darken-1"  @click.native="showModify=false">Cancel</v-btn>
		          	<v-btn color="green darken-1" class="mr-4"  @click.native="confirm">Save</v-btn>
		        </v-card-actions>
			</v-card>
		</v-layout>
	</div>
	</v-container>
</template>

<script>
import Vuex from 'vuex'
import Vue from 'vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import DBToggleBtn from './DBToggleBtn'

export default {
data () {
	return {
			showModify: 	false,
			selectedRoom: 	null,
			buildingRooms: 	{},
			currentRooms: 	null,
			newRooms: 		null,
			//roomDepts : { 'text': "9202", 'value': "1234"}

			newRoom: 	{	'bldgAlpha': 	null,
							'number': 		null,
							'deptID':       null, 
							'pctKey': 		null,
						},
	}
},

components : { DBToggleBtn },

watch: {   '$store.state.user.userProfile': async function (newval) {
		    	this.newRooms = await this.currentOccupancy({ 'employeeID': this.userProfile.employeeID })
		    	//console.log("newRooms ", this.newRooms)
		    	
		    	// Deep Copy so "current" doesn't change while modifying "new"
				this.currentRooms = JSON.parse(JSON.stringify(this.newRooms))
				this.loadRoomDictionary()
		    },
},

computed: {
	...mapState({   	darkTheme: state => state.ui.darkTheme,
						userProfile: state => state.user.userProfile,
				}),

	buildingItems : function () {
	  const items = []
	  this.$store.state.space.buildings.forEach(bldg => {
		bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
		bldg.value = bldg.bldgAlpha
		items.push(bldg)
	  })
	  return items
	},

	loading: function () {
		return this.$store.state.space.buildings.length == 0 // ADD OR'D BOOLEANS HERE FOR MORE LOADING 
	}
},

methods : {
	...mapMutations([ 	'setSnackText',
					]),
	...mapActions(['fetchBuildingRoomsFull', 'confirmOccupancy', 'currentOccupancy', 'fetchFullRoom']),

	addLine: function () {
		this.newRooms.push({...this.newRoom})
	},

	setDeptDefault: function (room) {
		// When a room is picked, set the Dept automatically if there is only one.
		console.log("Default Dept Set", room)
		if (room.number && this.roomDepts(room).length==1) {
			room.pctKey = this.roomDepts(room)[0].value
		}
		console.log("Room after setDeptDefault: ", room)
	},

	roomDepts: function (room) {
		if (!this.buildingRooms[room.bldgAlpha || !room]) { return }


		let fullRoom = this.buildingRooms[room.bldgAlpha] && 
		this.buildingRooms[room.bldgAlpha].find((searchRoom) => searchRoom.number == room.number)

/*		console.log("roomDepts: ", fullRoom && fullRoom.PCT.map((dept) => { return { 'text': dept.deptID, 'value': dept.key }}))*/
		return fullRoom && fullRoom.PCT.map((dept) => { return { 'text': dept.deptID, 'value': dept.key }})		
	},

	loadRoomDictionary : function () {
		this.newRooms.forEach(async (room) => {

			if (room.bldgAlpha && !this.buildingRooms[room.bldgAlpha] ) {
				let wholeRooms = await this.fetchBuildingRoomsFull(room.bldgAlpha)

				//Vue.set ensures that watchers (reactivity) is added to this array item
				Vue.set(this.buildingRooms, room.bldgAlpha, wholeRooms) 
			}
		})
		//console.log("Dictonary", this.buildingRooms)
	},

	confirm : function () {

		let rmpctArray = this.newRooms.map((room) => room.pctKey)
		let payload = {'employeeID': this.userProfile.employeeID, 'rmpctArray': rmpctArray}
		//console.log(payload)
		this.confirmOccupancy(payload).then( async(response) => { 
			this.setSnackText(response)
			if (response == "Saved" ) {
				this.currentRooms = await this.currentOccupancy({ 'employeeID': this.userProfile.employeeID })
				this.showModify = false
			}
		})	
		
	},

	delItem: function (index) {
		this.newRooms.splice(index, 1) // Remove from local memory
	},

	customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },
},
}

</script>

<style>
.fullpage {
	flex-direction: column;
	flex: 1;
	z-index: 10;
	position: fixed;
	top: 0px;
	width: 100vw;
	background-color: rgba(245, 245, 245, 1) !important;
	padding: 0px !important;
	margin-top: 0px;
	height: 100%;
	overflow: hidden !important;
}

.scrollable {
	flex-direction: column;
	flex: 1;
	z-index: 10;
	width: 100vw;
	background-color: rgba(245, 245, 245, 1) !important;
	padding: 0px !important;
	margin-top: 0px;
	height: calc(100% - 80px) !important;
	overflow: auto !important;	
}

.ouTile > .v-list__tile {
    align-items:  center;
    height: 40px;
}

.ouTile .v-input__slot {
	min-height: auto !important;
	margin-bottom: 0px !important;
}

.ouTile .v-input__control {
	min-height: auto !important;
	flex-wrap: unset !important;
	flex-direction: row !important;
}

.slimTile > .v-list__tile {
    align-items:  center;
    height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdateOccupancy.vue